import type { VisitorSearchParams } from "../../lib/visitor-search";

export function useEmbedMode(search: VisitorSearchParams) {
  return { isEmbed: search.embed === "true" };
}
